// GLOBAL APP CONTROLLER
const controller = {
	init() {
		const vtImage = jQuery(
			'.block-vt__left .block-vt__content:nth-child(1)'
		).attr('data-image');
		jQuery('.block-vt__right .block-vt__image').html(
			'<img src="' + vtImage + '" />'
		);
		jQuery('.block-vt__left .block-vt__content:nth-child(1)').addClass(
			'active'
		);

		jQuery('body').on('click', '.block-vt__content > h3', function () {
			const content = jQuery(this).closest('.block-vt__content');
			const image = content.attr('data-image');
			jQuery('.block-vt__right .block-vt__image').html(
				'<img src="' + image + '" />'
			);
			jQuery('.block-vt__content').removeClass('active');
			content.addClass('active');
		});
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
